import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { User } from "../models/user.model";
import { AbstractSecurityStorage, OidcSecurityService } from "angular-auth-oidc-client";
import { TokenService } from "../services/token/token.service";
import { OidcLoginContextService } from "./oidc-login-context.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  readonly USERDATA_KEY: string = "userData";

  constructor(
    private tokenService: TokenService,
    private oidcSecurityService: OidcSecurityService,
    private oidcLoginContext: OidcLoginContextService,
    private router: Router,
    private storageService: AbstractSecurityStorage
  ) { }

  login(): void {
    const configId = this.oidcLoginContext.getPendingConfigId();
    this.oidcSecurityService.authorize(configId);
  }

  logout(): void {
    const configId = this.oidcLoginContext.getPendingConfigId();
    this.oidcSecurityService.logoffAndRevokeTokens(configId).subscribe(() => {
      this.tokenService.removeToken();
      localStorage.removeItem("ip");
      void this.router.navigate([this.oidcLoginContext.getPendingConfigIdPath()]);
    });
  }

  setUserData(userData: string): void {
    this.storageService.write(this.USERDATA_KEY, userData);
  }

  clearToken(): void {
    this.tokenService.removeToken()
  }

  timeToken(): boolean {
    return this.tokenService.tokenExpired();
  }

  loadToken(url: string): void {
    this.tokenService.refreshToken(url);
  }

  setToken(token: string): void {
    this.tokenService.setToken(token);
  }

  getToken(): any {
    return this.tokenService.getToken()
  }

  getInfoToken(): any {
    return this.tokenService.getInfoToken()
  }

  getUserData(): User | undefined {
    return this.storageService.read(this.USERDATA_KEY)
      ? JSON.parse(String(this.storageService.read(this.USERDATA_KEY)))
      : undefined
  }

  getCheckAuth(): any {
    const configId = this.oidcLoginContext.getPendingConfigId();
    return this.oidcSecurityService.checkAuth(undefined, configId);
  }
}
